import React, { useContext } from 'react';
import { Link } from '@xo-union/tk-component-buttons';
import BasePublishWebsiteModalContent from '../BaseModalContent/BasePublishWebsiteModalContent';
import styles from './PublishWebsiteModalContent.scss';
import { TrackingContext } from '../../../../../TrackingContext';
import CopyToClipboardButton from '../../../../CopyToClipboardButton/CopyToClipboardButton';

interface PublishWebsiteModalContentProps {
  wwsUrl?: string;
  designerUrl?: string | null;
}

const PublishWebsiteModalContent = ({ wwsUrl, designerUrl }: PublishWebsiteModalContentProps) => {
  const defaultDesignerUrlHref = '/paper/invitations/wedding';
  const designerUrlHref = designerUrl || defaultDesignerUrlHref;

  const { track } = useContext(TrackingContext);

  const couponCode = 'WEBLOVE20';

  const linkClicked = () => {
    track('CTA Clicked', { reason: 'wws_publish_invitations' });
  };

  const onCouponCodeCopy = () => {
    track('CTA Clicked', { reason: 'wws_publish_coupon_copy' });
  };

  return (
    <BasePublishWebsiteModalContent
      header="Website published!"
      textContent={
        <>
          <div>Share the link and add your URL to your invitations so everyone has all the details.</div>
          <div
            className={styles.PublishWebsiteModalContent__EmphasizedText}
            data-testid="PublishWebsiteModalContent__WwsUrl"
          >
            {wwsUrl}
          </div>
        </>
      }
      bottomContent={
        <>
          Up next: Enjoy 20% off matching paper.
          <div
            className={styles.PublishWebsiteModalContent__CouponCode__Container}
            data-testid="PublishWebsiteModalContent__CouponCode__Container"
          >
            <div className={styles.PublishWebsiteModalContent__CouponCode__Spacer} />
            <div
              className={styles.PublishWebsiteModalContent__CouponCode__Code}
              data-testid="PublishWebsiteModalContent__CouponCode__Code"
            >
              {couponCode}
            </div>
            <CopyToClipboardButton
              textToCopy={couponCode}
              onCopy={onCouponCodeCopy}
              onCopyMessage="Copied coupon code to clipboard"
              dataTestId="PublishWebsiteModalContent__CouponCode__CopyButton"
              ariaLabel="Copy coupon code"
            />
          </div>
          <Link
            size="md"
            href={designerUrlHref}
            target="_blank"
            data-testid="PublishWebsiteModalContent__DesignerLink"
            onClick={linkClicked}
          >
            Order invitations
          </Link>
        </>
      }
    />
  );
};

export default PublishWebsiteModalContent;
